import { Link } from "react-router-dom";
import type { Novel } from "@/mocks/narutoContent";

export default function NovelCard({ novel }: { novel: Novel }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-shadow hover:shadow-soft">
      <Link to={`/xiaoshuo/${novel.id}`} className="relative block overflow-hidden" aria-label={novel.title}>
        <img
          src={novel.cover}
          alt={`${novel.title} 火影忍者同人小说封面`}
          title={`${novel.title} · 火影忍者同人小说`}
          className="h-52 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {novel.hot && (
          <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 font-label text-xs text-background-50">
            <i className="ri-fire-fill"></i> 热门
          </span>
        )}
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-2">
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-xs text-secondary-800">{novel.tag}</span>
          <span className="font-label text-xs text-foreground-500">{novel.words}</span>
        </div>
        <h3 className="mt-3 font-display text-xl text-foreground-950 leading-snug">
          <Link to={`/xiaoshuo/${novel.id}`} className="hover:text-primary-700 transition-colors">{novel.title}</Link>
        </h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{novel.summary}</p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1"><i className="ri-account-circle-line text-base"></i>{novel.author}</span>
          <span className="inline-flex items-center gap-3">
            <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{novel.views}</span>
            <span className="inline-flex items-center gap-1 text-accent-600"><i className="ri-heart-3-line"></i>{novel.likes}</span>
          </span>
        </div>
      </div>
    </article>
  );
}